import { combineReducers } from 'redux';
import limits from './limits/limitsReducer';
import user from './user/userReducer';
import { reducer as details } from './detailsModule';

export default combineReducers({
	details,
	limits,
	user,
});
